import React, { useCallback, useEffect, useRef } from 'react'
import { Loading, Dots } from './styleds'
import { getElementTop } from '../../utils/func'

interface InfiniteScrollProps {
  loading: boolean
  loadedAll: boolean
  children: React.ReactNode
  loadmore: () => void
}

const InfiniteScroll = ({ children, loading, loadedAll, loadmore }: InfiniteScrollProps) => {

  const loadingEl = useRef(null)

  const scrollBar = useCallback(() => {
    if (loading || loadedAll) return
    
    const loadmoreEl = loadingEl && loadingEl.current
    let dom = document.getElementById("BodyContainer")
    if (!loadmoreEl || !dom) return
    const scrollTop = dom.scrollTop || dom.scrollTop
    const clientHeight = dom.clientHeight || dom.clientHeight
    const offsetTop = getElementTop(loadmoreEl)
    const offset = offsetTop - scrollTop

    if (offset < clientHeight) {
      loadmore()
    }
  }, [loadingEl, loading, loadedAll, loadmore])

  useEffect(() => {
    let dom = document.getElementById("BodyContainer")
    if(dom){
      dom.addEventListener('scroll', scrollBar)
    }
    return () =>  {
      if(dom){
        dom.removeEventListener('scroll', scrollBar) 
      }
    }
  }, [scrollBar])

  return (
    <>
      {children}
      {!loadedAll && (
        <Loading align={'center'} ref={loadingEl}>
          <Dots>Loading</Dots>
        </Loading>
      )}
    </>
  )
}

export default InfiniteScroll
